import { useMutation } from '@apollo/client'
import { Badge } from '@chain-zen/ui'
import { useState } from 'react'
import { toast } from 'sonner'

import { BaseStatusMenu } from '../../../../../components/base-status-menu'
import { ASSIGN_SHIPMENT_PRIORITY } from '../../../../../data/mutations/shipment'
import { getPriorityColor } from '../../../../../utils/shipment'

// List of priorities
const priorities = ['P0', 'P1', 'P2', 'P3', 'P4', 'Stretch']

interface IPriorityMenuProps {
  currentPriority: string | null
  shipmentID: string
}

/**
 * This component is used to display a priority selection menu for a shipment.
 */
export const PriorityMenu = ({ currentPriority, shipmentID }: IPriorityMenuProps) => {
  const [selectedPriority, setSelectedPriority] = useState<string>(currentPriority || '')

  // Mutation hook for updating the shipment priority
  const [updateShipmentPriority] = useMutation(ASSIGN_SHIPMENT_PRIORITY, {
    onError: () => {
      toast.error('Failed to update shipment priority')
      // Revert to previous value on error
      setSelectedPriority(currentPriority || '')
    }
  })

  const handlePriorityChange = ({ status }: { status: string }) => {
    setSelectedPriority(status)

    // Only update if the value has changed
    if (status !== currentPriority) {
      updateShipmentPriority({
        variables: {
          priority: status,
          shipmentID
        }
      })
    }
  }

  return (
    <BaseStatusMenu
      canEdit={true}
      currentStatus={selectedPriority}
      handleUpdateStatus={handlePriorityChange}
      labelComponent={(status: string) => (
        <Badge variant="secondary" className={getPriorityColor(status || 'stretch')}>
          {status || 'Priority missing'}
        </Badge>
      )}
      statuses={priorities}
    />
  )
}
